import {useDebugValue, useEffect, useState} from 'react';

import {noop} from '../utils';

function useInitialization(initializer = noop) {
    const [
        isInitialized,
        setIsInitialized
    ] = useState(false);

    /* eslint-disable react-hooks/exhaustive-deps */
    useEffect(function initialize() {
        setIsInitialized(true);

        return initializer();
    }, []);
    /* eslint-enable react-hooks/exhaustive-deps */

    const result = {
        isInitialized
    };

    useDebugValue(result);

    return result;
}

export {useInitialization};
